import {createTheme} from "@mui/material";

export const appTheme = createTheme({
    palette: {
        primary: {
            main: '#054E8F',
        },
        secondary: {
            main: '#F7BE08'
        },
        success: {
            main: '#54952e'
        },
        error: {
            main: '#b34f4f'
        }
    },
});